import { Download } from "lucide-react";

import { Button } from "@buildpy/ui/button";
import { signedDownload } from "@/lib/signed-url";

// 시공사례 「사진 묶음(ZIP)」 — 사진 원본(위치 정보 제거) + 글.html·글.txt, 비공개 사례도 받는다.
const ExportZipButton = ({ portfolioId }: { portfolioId: string }) => (
  <div className="flex min-w-0 flex-col gap-y-1" data-testid="portfolio-export-zip">
    <Button asChild size="sm" variant="outline">
      <a download href={`/app/portfolio/${encodeURIComponent(portfolioId)}/export`} onClick={signedDownload(`/app/portfolio/${encodeURIComponent(portfolioId)}/export`)}>
        <Download className="size-4" />
        사진 묶음(ZIP)
      </a>
    </Button>
  </div>
);

export default ExportZipButton;
